import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths';
import { getFileReactQuery } from '@dealstack/frontend/shared/dataExchange/services/mip.service.ts';

// The original uploaded PDF bytes. `enabled` is false for a Word template: its surface is the
// converted document from another endpoint, so fetching the .docx would be bytes for nothing.
export const useGlobalTemplateFile = (fileId: string, enabled = true) =>
	useQuery({
		queryKey: [API_PATHS.FILE_ID_GET, { id: fileId }, 'global-document-template'],
		queryFn: async ({ signal }) => {
			const response = await getFileReactQuery({ id: fileId }, signal);
			return response ? await response.blob() : undefined;
		},
		enabled,
	});
